import React, { useContext, useEffect, useState } from "react";
import * as S from "./Message.style"
import { ThemeContext } from 'styled-components';
import remarkGfm from "remark-gfm";
import ReactMarkdown from "react-markdown";

function Message({ 
  message, 
  option, 
  time, 
  date, 
  senderName, 
  link,
  children,
  file
}) {

  const theme = useContext(ThemeContext);
  
  const [colorByType, setColorByType] = useState("");
  const [messageEdited, setMessageEdited] = useState("");
  const [isImageFile, setIsImageFile] = useState(null);  
  const [loadingFile, setLoadingFile] = useState(false);

  useEffect(() => {
    let messageTemp = message;
    messageTemp = messageTemp?.replace('{{medicine}}','');
    setMessageEdited(messageTemp);

    let result = message?.includes("{{medicine}}");
    if(result) {
      setColorByType(theme.primarySectionMedicines);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function renderMessage(children, link, messageEdited) {
    let message;
    if (children) {
      message = children;
    } else {
      if (link) {
        message = <a href={messageEdited} target="_blank" rel="noopener noreferrer">{messageEdited}</a>;
      } else {
        message = messageEdited;
      }
    }
    return message;
  }

  function checkIfImage(url) {
    setLoadingFile(true);
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        resolve(true);
        setLoadingFile(false);
      };
      img.onerror = () => {
        resolve(false);
        setLoadingFile(false);
      };
      img.src = url;
    });
  }

  function getFileNameFromUrl(url) {    
    return url.split('/').pop().split('?')[0].split('#')[0];
  }

  useEffect(() => {
    async function checkFile() {
      if (file) {
        const isImage = await checkIfImage(file);
        setIsImageFile(isImage);
      }
    }
    checkFile();
  }, []);

  function openFile() {
    window.open(file, "_blank", "noopener,noreferrer");
  }

  const reactMarkdownComponents = (text) => {
    return (
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          strong: ({ children }) => (
            <strong style={{ fontWeight: "bold" }}>{children}</strong>
          ),
          em: ({ children }) => (
            <em style={{ fontStyle: "italic" }}>{children}</em>
          ),
          a: ({ href }) => (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#2a4bd7", wordBreak: "break-word" }}
            >
              {href}
            </a>
          ),
          ul: ({ children }) => (
            <ul
              style={{
                paddingLeft: "1.5em",
                listStyleType: "disc",
                listStylePosition: "outside",
                margin: 0,
              }}
            >
              {children}
            </ul>
          ),
          ol: ({ children }) => (
            <ol
              style={{
                paddingLeft: "1.5em",
                listStyleType: "decimal",
                listStylePosition: "outside",
                margin: 0,
              }}
            >
              {children}
            </ol>
          ),
          li: ({ children }) => (
            <li
              style={{
                wordBreak: "break-word",
                marginBottom: "0.75em",
                paddingLeft: "0.25em", // para alinear multilínea
              }}
            >
              {children}
            </li>
          )
        }}
      >
        {text}
      </ReactMarkdown>
    )
  };

  return (
    <S.Message 
      time={time} 
      option={option} 
      color={colorByType}
    >
      <div className="message__sender-name">{senderName}</div> 
      { option === 'doctor' ? 
        <div className="message message--patient" time={time}>
          {
            loadingFile && file &&
            <div className="message__loading">
              
            </div>
          }
          {
            file && isImageFile !== null && (
              isImageFile ? (
                <div className="message__img">
                  <button className="download-button"
                    onClick={openFile}
                  >
                    <i className="download-button__icon icon zaia-i-download"></i>
                  </button>
                  <img src={file} alt="" className="message__img-file" 
                    onClick={openFile}
                  />
                </div>
              ) : (
                <div className="message__pdf"
                  onClick={openFile}
                >
                  <button className="download-button">
                    <i className="download-button__icon icon zaia-i-download"></i>
                  </button>
                  <div className="message__pdf-icon">
                    <i className="icon zaia-icon-file"></i>
                  </div>
                  <div className="message__pdf-footer">
                    {getFileNameFromUrl(file)}
                  </div>
                </div>
              )
            )
          }
          <div className="message__text">
            {
              children 
              ? children 
              : reactMarkdownComponents(messageEdited)
            }
          </div>
          <div className="message__tail--patient">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
              <path d="M19 16.7502C9.89773 18.4052 2.96759 13.6472 0.640306 11.0613L0.898893 3.30368C3.39857 3.82085 8.81166 4.28631 10.4666 2.01074C10.208 11.3199 17.1899 15.9745 19 16.7502Z" fill="#1F1F52" stroke="#1F1F52" stroke-width="0.805851"/>
            </svg>
          </div>
        </div> :
        <div className="message message--reciever">
          {
            file && isImageFile !== null && (
              isImageFile ? (
                <div className="message__img">
                  <button className="download-button"
                    onClick={openFile}
                  >
                    <i className="download-button__icon icon zaia-i-download"></i>
                  </button>
                  <img src={file} alt="" className="message__img-file" 
                    onClick={openFile}
                  />
                </div>
              ) : (
                <div className="message__pdf"
                  onClick={openFile}
                >
                  <button className="download-button">
                    <i className="download-button__icon icon zaia-i-download"></i>
                  </button>
                  <div className="message__pdf-icon">
                    <i className="icon zaia-icon-file"></i>
                  </div>
                  <div className="message__pdf-footer">
                    {getFileNameFromUrl(file)}
                  </div>
                </div>
              )
            )
          }
          <div className="message__text">
            {
              children
              ? renderMessage(children, link, messageEdited)
              : reactMarkdownComponents(
                renderMessage(children, link, messageEdited)
              )
            }
          </div>
          <div className="message__tail--reciever">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
              <path d="M2 16.7502C11.1023 18.4052 18.0324 13.6472 20.3597 11.0613L20.1011 3.30368C17.6014 3.82085 12.1883 4.28631 10.5334 2.01074C10.792 11.3199 3.81011 15.9745 2 16.7502Z" fill="#E8E7F4" stroke="#E8E7F4" stroke-width="0.805851"/>
            </svg>
          </div>
        </div>
      }
      {
        time && date ? 
        <div className="message__time">{time} - {date}</div> : null
      }
    </S.Message>
  );
}

export default Message;
